import { render, staticRenderFns } from "./NotificationContent.vue?vue&type=template&id=60e66af8&scoped=true&"
import script from "./NotificationContent.vue?vue&type=script&lang=js&"
export * from "./NotificationContent.vue?vue&type=script&lang=js&"
import style0 from "./NotificationContent.vue?vue&type=style&index=0&id=60e66af8&scoped=true&lang=css&"
import style1 from "./NotificationContent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e66af8",
  null
  
)

export default component.exports